/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serviceerrormessage2Inputs */



/**
* | output |
* | --- |
* | "Something went wrong. Please try again later." |
*
* @param {Serviceerrormessage2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const serviceerrormessage2 = /** @type {((inputs?: Serviceerrormessage2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serviceerrormessage2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Something went wrong. Please try again later.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algo salió mal. Inténtalo más tarde.")
	return /** @type {LocalizedString} */ ("Не получилось. Попробуй чуть позже.")
});
export { serviceerrormessage2 as "serviceErrorMessage" }